export const hexToRgba = (hex) => {
  const r = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
  return r ? parseInt(r[1], 16) +',' + parseInt(r[2], 16) +',' + parseInt(r[3], 16) : null;
}

export const getUrlVars = () => {
  let qsKw = {}
  let pathKw = {};

  const match = window.location.href.match(/public\/(?<public>\w+)/);
  if (match) {
    pathKw = match.groups;
  }

  if (window.location.href.indexOf('?') !== -1) {
    let kwargs = window.location.href.slice(window.location.href.indexOf('?') + 1);
    if (kwargs) {
      kwargs.split('&').forEach(kw => {
        const [k, v] = kw.split('=');
        qsKw[k] = decodeURI(v);
      });
    }
  }

  return [qsKw, pathKw];
}

export class DefaultMap extends Map {
  constructor(getDefaultValue, ...mapConstructorArgs) {
    super(mapConstructorArgs);

    if (typeof getDefaultValue !== 'function') {
      throw new Error('getDefaultValue must be a function');
    }

    this.getDefaultValue = getDefaultValue;
  }

  get = key => {
    if (!this.has(key)) {
      this.set(key, this.getDefaultValue(key));
    }

    return super.get(key);
  };
}

export class Observable {
  constructor(obj, cb) {
    return new Proxy(obj, {
      set: (t, k, v) => { cb(k, v); t[k] = v; return true; },
    })
  }
}
